import * as React from 'react';
import ChartCard from '../ChartCard';
import Grid from '@material-ui/core/Grid';
import { DataMap, Monitor } from 'src/classes';
import { Alert, AlertContainer, cols, Props } from 'src/types';
import { reduceAlertsToDateRange } from 'src/utils/alerts';

export const buildChartCard = (cols: cols, map: DataMap, props: Props, index: number) => {
      const { classes } = props;
      const monitor = map.monitor;
      const { alertsArray, order } = setAlertsAndOrder(monitor, props);
      const title = monitor.type === "response" ? monitor.friendlyName : monitor.friendlyName + " FTP Transfers";
      return {
        order,
        element:
        <Grid item xs={cols} key={index}>
          <ChartCard
            className={classes.chart}
            {...props}
            title={title}
            data={map}
            alerts={alertsArray}
            type={monitor.type}
            monitorId={monitor.id}
            alertCutoff={monitor.alertCutoff}
          />
        </Grid>
      } 
}
const setAlertsAndOrder = (monitor: Monitor, props: Props) => {
  const alerts: AlertContainer = props.alerts;
    const alertsArray: any[] = setAlertsArray(alerts, monitor.id, props.rangeSetting);
    if(alertsArray.length === 0) {
      return {
        alertsArray,
        order: 0
      }
    } else {

      const order = setOrder(alertsArray);
    return {
      alertsArray,
      order,
    }
  }
}

const setAlertsArray = (alerts: AlertContainer, monitorId: string, rangeSetting: number) => {
  return alerts[monitorId]
      ? alerts[monitorId].length > 0 
        ? reduceAlertsToDateRange(alerts[monitorId], rangeSetting) 
        : []
      : [];
}

const setOrder = (alertsArray: Alert[]) => {
  const lastAlertTime = parseInt(alertsArray[alertsArray.length - 1].time);
  const notAllActiveAlerts = alertsArray.some((alert: Alert) => {
    return alert.cleared === true;
  });
  const order =alertsArray.length > 0 
    ? !notAllActiveAlerts
      ? lastAlertTime * 10
      : lastAlertTime
    : 0;
  return alertsArray.some((alert: Alert) => {return alert.critical === true}) ? order * 10 : order;
}


// WEBPACK FOOTER //
// ./src/components/ChartCard/utils/buildChartCard.tsx